module.exports = __webpack_public_path__ + "static/media/landing-animation-3.18a43f12.gif";